/**
 * Essential Cart Drawer — Türkçe metin çevirisi
 * Uygulama ayarları İngilizce kaldığında müşteriye görünen metinleri TR yapar.
 */
(function essentialCartTurkish() {
  const MAP = [
    ['You may also like', 'Bunları da beğenebilirsiniz'],
    ['Add discount code', 'İndirim kodu ekle'],
    ['Discount code', 'İndirim kodu'],
    ['Code not applicable', 'Kod geçerli değil'],
    ["can't be applied", 'uygulanamıyor'],
    ['Your cart is empty', 'Sepetiniz boş'],
    ['Continue shopping', 'Alışverişe devam et'],
    ['Special instructions for the courier', 'Kurye için özel notunuz'],
    ['Order note must be filled to checkout', 'Ödeme için sipariş notu gerekli'],
    ['Get it while it lasts', 'Stoklar tükenmeden alın'],
    ['This price expires in', 'Bu fiyatın bitmesine'],
    ['Free shipping on $50 | Free gift on $60', '1000 TL üzeri ücretsiz kargo · Kapıda ödeme'],
    ['Add to cart', 'Sepete Ekle'],
    ['+ Add', '+ Ekle'],
    ['Sold out', 'Tükendi'],
    ['Add note', 'Sipariş notu'],
    ['Savings', 'Kazancınız'],
    ['Subtotal', 'Ara toplam'],
    ['All Rewards', 'Tüm ödüller'],
    ['unlocked!', 'açıldı!'],
    ['Checkout', 'Ödemeye Geç'],
    ['Quantity', 'Adet'],
    ['Remove', 'Kaldır'],
    ['Save', 'Kaydet'],
    ['Add', 'Ekle'],
    ['Cart', 'Sepet'],
  ];

  MAP.sort((a, b) => b[0].length - a[0].length);

  const SHORT = new Set(['Add', 'Cart', 'Save', 'Remove', 'Checkout', 'Quantity', 'Savings', 'Subtotal']);

  function translateText(value) {
    if (!value || typeof value !== 'string') return value;
    let out = value;
    for (const [en, tr] of MAP) {
      if (!out.includes(en)) continue;
      if (SHORT.has(en)) {
        out = out.replace(new RegExp('\\b' + en.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'g'), tr);
      } else {
        out = out.split(en).join(tr);
      }
    }
    out = out.replace(/\bCart\s*[•·]\s*/g, 'Sepet · ');
    return out;
  }

  function walk(node) {
    if (!node) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const next = translateText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    for (const attr of ['placeholder', 'aria-label', 'title', 'alt']) {
      if (node.hasAttribute?.(attr)) {
        const v = node.getAttribute(attr);
        const t = translateText(v);
        if (t !== v) node.setAttribute(attr, t);
      }
    }

    if (node.shadowRoot) walk(node.shadowRoot);

    const children = node.childNodes;
    for (let i = 0; i < children.length; i++) walk(children[i]);
  }

  function run() {
    const roots = [
      document.getElementById('essential-cart-drawer-portal'),
      document.querySelector('essential-cart-app-embed'),
      ...document.querySelectorAll('[id*="essential"], [class*="essential-cart"], [class*="Essential"]'),
    ].filter(Boolean);

    [...new Set(roots)].forEach((root) => walk(root));
  }

  const observer = new MutationObserver(() => {
    clearTimeout(observer._t);
    observer._t = setTimeout(run, 40);
  });

  function start() {
    run();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function preventEssentialCartAutoOpen() {
  try {
    Object.defineProperty(window, 'essentialCartPreventAutoOpenPaths', {
      configurable: true,
      get() {
        return [window.location.pathname || '/'];
      },
    });
  } catch (error) {
    window.essentialCartPreventAutoOpenPaths = [window.location.pathname || '/'];
  }

  let userOpened = false;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (
        target.closest('[data-testid="cart-drawer-trigger"]') ||
        target.closest('.header-actions__cart-icon') ||
        target.closest('#essential-cart-drawer-portal')
      ) {
        userOpened = true;
        setTimeout(() => {
          userOpened = false;
        }, 2500);
      }
    },
    true
  );

  function closeAutoOpenedDrawer() {
    if (userOpened) return;
    const portal = document.getElementById('essential-cart-drawer-portal');
    if (!portal) return;
    const closer = portal.querySelector(
      'button[aria-label="Close"], button[aria-label="Kapat"], button[aria-label*="close" i], [data-close]'
    );
    if (closer instanceof HTMLElement) closer.click();
    portal.querySelectorAll('dialog[open]').forEach((dialog) => {
      if (typeof dialog.close === 'function') dialog.close();
    });
  }

  document.addEventListener('cart:update', () => {
    closeAutoOpenedDrawer();
    setTimeout(closeAutoOpenedDrawer, 60);
    setTimeout(closeAutoOpenedDrawer, 250);
    setTimeout(closeAutoOpenedDrawer, 600);
  });
})();
